import { useTranslation } from "react-i18next";
import { Button } from '@mui/material';
import ExcelJS from 'exceljs';

const CommonExcelDownload = ({excelDatas, excelHeader, excelHeader2, title, filename}) => {
    const { t } = useTranslation();
    
    const wb = new ExcelJS.Workbook();
    const ws = wb.addWorksheet('Sheet1', {
      pageSetup: {
        paperSize: 9,
        orientation: 'landscape',
        horizontalCentered: true,
      },
    });
    ws.pageSetup.margins = {
      left: 0.7,
      right: 0.7,
      top: 0.75,
      bottom: 0.75,
      header: 0.3,
      footer: 0.3,
    };
  
    let excelData = [];
    excelData.push(
      {
        data: [title],
      },
      {
        data: [],
      }
    );

    // headerTitle
    excelData.push({data : excelHeader});
    excelHeader2 && excelHeader2.length > 0 && excelData.push({data : excelHeader2});

    // excelData
    excelHeader2 && excelHeader2.length > 0 && excelDatas.shift();

    excelDatas.forEach((item, index) => {
        excelData.push({data : item});
    });
  
    excelData.forEach((item, index) => {
      ws.getRow(index + 1).values = [...item.data];
    });
  
    let dataStartIdx = 4;
    if (excelHeader2 && excelHeader2.length > 0) {
        dataStartIdx = 5;
    }
    // 셀 병합
    let charCode;
    if ((excelHeader.length-1) < 26) {
        charCode = String.fromCharCode(65+(excelHeader.length-1));
    } else {
        let firstStr = String.fromCharCode(65+parseInt((excelHeader.length-1)/26)-1);
        let secondStr = String.fromCharCode(65+((excelHeader.length-1)%26));
        charCode = firstStr+secondStr;
    }
    ws.mergeCells('A1:'+charCode+'1');

    // 폰트 사이즈, 굵기, 색상 변경
    ws.getCell('A1').font = { size: 18, bold: true, color: { argb: '000000' } };
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').font = { bold: true };
    });
    excelHeader2 && excelHeader2.length > 0 && excelHeader2.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'4').font = { bold: true };
    }); 

    // 정렬
    ws.getCell('A1').alignment = { horizontal: 'center', vertical: 'middle' };
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').alignment = { horizontal: 'center', vertical: 'middle' };
    });
    excelHeader2 && excelHeader2.length > 0 && excelHeader2.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'4').alignment = { horizontal: 'center', vertical: 'middle' };
    });
    excelDatas.forEach((item, index) => {
        excelHeader.forEach((item2, index2) => {
            let charCode;
            if (index2 < 26) {
                charCode = String.fromCharCode(65+index2);
            } else {
                let firstStr = String.fromCharCode(65+parseInt(index2/26)-1);
                let secondStr = String.fromCharCode(65+(index2%26));
                charCode = firstStr+secondStr;
            }
            ws.getCell(charCode+(index+dataStartIdx)).alignment = { horizontal: 'center', vertical: 'middle' };
        });
    });

    // 색 칠하기
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'e0e0e0' },
        };
    });
    excelHeader2 && excelHeader2.length > 0 && excelHeader2.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'4').fill = {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'f9f8dc' },
        };
    });
    
    // 테두리
    excelHeader && excelHeader.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'3').border = {
            top: { style: 'medium', color: { argb: '000000' } },
        };
    });
    excelHeader2 && excelHeader2.length > 0 && excelHeader2.forEach((item, index) => {
        let charCode;
        if (index < 26) {
            charCode = String.fromCharCode(65+index);
        } else {
            let firstStr = String.fromCharCode(65+parseInt(index/26)-1);
            let secondStr = String.fromCharCode(65+(index%26));
            charCode = firstStr+secondStr;
        }
        ws.getCell(charCode+'4').border = {
            top: { style: 'thin', color: { argb: '000000' } },
        };
    });
    excelDatas.forEach((item, index) => {
        
        excelHeader && excelHeader.forEach((item2, index2) => {
                let charCode;
                if (index2 < 26) {
                    charCode = String.fromCharCode(65+index2);
                } else {
                    let firstStr = String.fromCharCode(65+parseInt(index2/26)-1);
                    let secondStr = String.fromCharCode(65+(index2%26));
                    charCode = firstStr+secondStr;
                }
                ws.getCell(charCode+(index+dataStartIdx)).border = {
                    top: { style: 'thin', color: { argb: '000000' } },
                };
                if (index === (excelDatas.length-1)) {
                    let charCode;
                    if (index2 < 26) {
                        charCode = String.fromCharCode(65+index2);
                    } else {
                        let firstStr = String.fromCharCode(65+parseInt(index2/26)-1);
                        let secondStr = String.fromCharCode(65+(index2%26));
                        charCode = firstStr+secondStr;
                    }
                    ws.getCell(charCode+(index+dataStartIdx)).border = {
                        top: { style: 'thin', color: { argb: '000000' } },
                        bottom: { style: 'thin', color: { argb: '000000' } },
                    };
                }
            });
    });

    // 가로 길이
    const col = [];
    for (let i = 0; i < excelHeader.length; i++) {
        col.push({
            key: 'data',
            width: 15,
        });
    }
    ws.columns = col;
  
    // 세로 길이
    for (let i = 1; i <= excelData.length; i++) {
      let row = ws.getRow(i);
      row.height = 22;
    }
  
    const download = () => {
        let promise = [];
        Promise.all(promise).then(() => {
            wb.xlsx.writeBuffer().then((b) => {
                let a = new Blob([b]);
                let url = window.URL.createObjectURL(a);
        
                let elem = document.createElement('a');
                elem.href = url;
                elem.download = filename;
                elem.click();
                elem.remove();
            });
        });
    }

    return (
        <Button
        className="pop_style_btn"
        onClick={download}
        >
        <span>{t('message.common.btn.excel.download')}</span>

        <svg
            width="15"
            height="15"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            style={{
            display: "block",
            flexShrink: 0
            }}
        >
            <path d="M12 3v13M6 11l6 6 6-6M4 21h16" />
        </svg>
        </Button>
    )
};

export default CommonExcelDownload;